import { LoginAuthApiNamespace } from '@core/models/api';

export namespace LoginAuthNamespace {
  export interface IN {
    login: string;
    password: string;
    recaptchaToken: string;
  }

  export class OUT {
    accessToken: string = '';
    expiresAt: number = 0;
    login: string = '';

    constructor() {}

    init(input: LoginAuthApiNamespace.OUT) {
      this.accessToken = input.accessToken;
      this.expiresAt = input.expiresIn;
      // this.login = input.login;
      return this;
    }
  }
}
